<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerHSRs">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(hSR)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { HSRService } from "../../../services/HSRService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "HSRPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      hSR: null,
      hSRService: new HSRService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerHSRs() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.hSR) {
        return {
          title: this.hSR.value,
          id: this.ids[0],
          status: this.getStatus(this.hSR.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.hSR) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.hSR.code,
            },
          ],
          [
            {
              title: this.$t("hSRValue"),
              text: this.hSR.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.hSR) {
        return [
        [
            {
              title: this.$t("createdByTxt"),
              text: this.hSR.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.hSR.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.hSR.createdAt) + ' ' + getAMorPM(this.hSR.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.hSR.lastUpdated) + ' ' + getAMorPM(this.hSR.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots
        ? this.filterAccessDots(options, this.hSR)
        : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getHSR();
      } catch (e) {
        this.hasError = true;
      }
    },
    getHSR() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.hSRService.get(this.ids[0]).then((res) => {
          this.hSR = res.data;
          this.loading = false;
        });
      }
      this.hSR = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.hSR);
    },
    deletePanel() {
      this.$emit("delete", this.hSR);
    },
    showHistoryPanel() {
      this.$emit("history", this.hSR);
    },
  },
};
</script>

<style scoped></style>
